import { makeIdTAccAyDrShowLogic } from './helpers';
export var showLogic = makeIdTAccAyDrShowLogic({});
